import { resolveMediaUrl } from './mediaUrl';

const PRODUCT_IMAGE_SIZES = new Set(['small', 'medium', 'large']);
const PLACEHOLDER = '/placeholder.png';

export const buildProductImageUrl = (image, size = 'small') => {
  if (!PRODUCT_IMAGE_SIZES.has(size)) {
    throw new Error(`Unsupported product image size: ${size}`);
  }

  const value = typeof image === 'string' ? image.trim() : '';
  if (!value || value === PLACEHOLDER || value === 'placeholder.png') return PLACEHOLDER;
  if (/^(?:data:|blob:)/i.test(value)) return value;

  let normalizedPath = value;
  try {
    normalizedPath = new URL(value, 'http://localhost').pathname;
  } catch (error) {
    // Fall back to parsing the supplied value as a relative path.
  }

  const pathWithoutQuery = normalizedPath.split(/[?#]/, 1)[0];
  const sourceFilename = pathWithoutQuery.split('/').filter(Boolean).pop();
  if (!sourceFilename) return PLACEHOLDER;
  const filename = sourceFilename.replace(/\.[^.]+$/, '') + '.webp';

  return resolveMediaUrl(`/uploads/products/${size}/${encodeURIComponent(filename)}`);
};

export const buildProductImageDescriptor = (image, sizes = '(max-width: 575px) 50vw, (max-width: 991px) 33vw, 300px') => ({
  src: buildProductImageUrl(image, 'small'),
  srcSet: [
    `${buildProductImageUrl(image, 'small')} 300w`,
    `${buildProductImageUrl(image, 'medium')} 600w`,
    `${buildProductImageUrl(image, 'large')} 1200w`,
  ].join(', '),
  sizes,
});
